import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { api } from '@/global/services/api'

export default {
  methods: {
    showEdit (event) {
      const { data } = event || {}
      this.$set(this.manageWorkingPlaceDialogConfig, 'title', this.$t('people/person-work-place.edit_working_place') + (data?.description ? ' - ' + data.description : ''))
      this.$set(this.manageWorkingPlaceDialogConfig, 'createMode', false)
      this.$set(this.manageWorkingPlaceDialogConfig, 'editData', data)
      this.$set(this.manageWorkingPlaceDialogConfig, 'show', true)
    },

    onWorkingPlaceDelete (event) {
      const { id, description } = event?.data || {}
      if (!id) {
        return
      }

      const title = this.$t('people/working-places.delete')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (description || '/'))
      this.$set(this.informationDialogConfig, 'positiveBtnText', this.$t('base.save'))
      this.$set(this.informationDialogConfig, 'message', this.$t('people/working-places.confirm_delete'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.workingPlaceDelete(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async workingPlaceDelete (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.peopleWorkingPlaces || {}

        await api('people').delete(`person-working-places/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
